import { get, post, patch, del } from './client.js';

export const orgSsoApi = {
  list:        (orgId)      => get(`/orgs/${orgId}/sso/providers`),
  get:         (orgId, id)  => get(`/orgs/${orgId}/sso/providers/${id}`),
  create:      (orgId, dto) => post(`/orgs/${orgId}/sso/providers`, dto),
  update:      (orgId, id, dto) => patch(`/orgs/${orgId}/sso/providers/${id}`, dto),
  remove:      (orgId, id)  => del(`/orgs/${orgId}/sso/providers/${id}`),
  setDefault:  (orgId, id)  => post(`/orgs/${orgId}/sso/providers/${id}/set-default`, {}),
  test:        (orgId, id)  => post(`/orgs/${orgId}/sso/providers/${id}/test`, {}),
};
